export default __webpack_public_path__ + "static/media/no-search-results.d551a0aa.svg";